module.exports = __webpack_public_path__ + "static/media/file-ai.63717e9a.svg";